import {
  REQUEST_ONSHELFAVAILABILITY,
  REQUEST_ONSHELFAVAILABILITY_DONE,
  OnShelfAvailabilityActions
} from "./types";
import {
  SalesStatistic,
  OnShelfAvailabilityStatistics
} from "../../../models/Statistics";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";

function fetchOnShelfAvailability(): OnShelfAvailabilityActions {
  return {
    type: REQUEST_ONSHELFAVAILABILITY,
    payload: []
  };
}

function fetchOnShelfAvailabilityDone(
  onShelfAvailability: ReadonlyArray<OnShelfAvailabilityStatistics>
): OnShelfAvailabilityActions {
  return {
    type: REQUEST_ONSHELFAVAILABILITY_DONE,
    payload: onShelfAvailability
  };
}

/* Thunks goes here */
export const thunkFetchOnShelfAvailabilityStatistics = (
  periodFrom: Date,
  periodTo: Date
) => async (dispatch: any) => {
  try {
    dispatch(fetchOnShelfAvailability());
    const result = await StatisticsApi.getOnShelfAvailabilityStatistics(
      periodFrom,
      periodTo
    );

    if (isOk(result)) {
      dispatch(fetchOnShelfAvailabilityDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchOnShelfAvailabilityDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
